
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"opacity":".8","clip-path":"url(#clip0_20836_132924)","fill-rule":"evenodd","clip-rule":"evenodd","fill":"#fff"}},[_c('path',{attrs:{"d":"M10.238 5.903V3.107H21.7v6.837h-2.14v2.3h3.64a.8.8 0 00.8-.8V1.607a.8.8 0 00-.8-.8H8.738a.8.8 0 00-.8.8v4.296h2.3z"}}),_c('path',{attrs:{"d":"M0 7.83a.7.7 0 01.7-.7H18.416a.7.7 0 01.7.7v.832a.7.7 0 01-.7.7v9.306a.7.7 0 01-.7.694h-7.043v1.13l2.531 2.531a.7.7 0 010 .99l-.587.588a.7.7 0 01-.99 0L9.59 22.564h-.063l-2.038 2.038a.7.7 0 01-.99 0l-.587-.588a.7.7 0 010-.99l2.53-2.53v-1.132H1.4a.7.7 0 01-.7-.7V9.362a.7.7 0 01-.7-.7V7.83zm2.93 1.532h13.256v7.769H2.93V9.36z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_20836_132924"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .807)","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    